// script (example — cookie_domain is set per test store at admin injection time)
// <script src="https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/js/ab-script.js?experiment_id=WSK_POSTUPSN_2026_06_26_skladovost_boxspring_skrine&variants=['A','B','C','D','E','F','G','H','I','J']&cookie_days=90&cookie_domain=.<TEST_STORE>.myshoptet.com"></script>


// HELPER FUNKCIE
function abGetCookie(name) {
    if (!name) return null;
    const safeName = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + safeName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function abGetAssignment(experimentId) {
    const value = abGetCookie('ab_tests');
    if (!value) return null;

    const tests = value.split('|');
    for (let test of tests) {
        const [testName, variant] = test.split(':');
        if (testName === experimentId) {
            return variant;
        }
    }
    return null;
}

// získanie breadcrumbs
function abGetBreadcrumbs() {
    return Array.from(document.querySelectorAll('.breadcrumbs [itemprop="name"]'))
                .map(el => el.textContent.trim().toLowerCase());
}

// TESTY -----------------------
function abTestConfig() {
    runCheckoutTest();

    if (shopName === 'wsk') {
        runSkladAllTest();
    }

    // pre ajax spustíme znova
    if (shopName === 'wsk') {
        document.addEventListener('ShoptetDOMContentLoaded', function() {
            runSkladAllTest();
        });
    }
}

//SKLADOVÁ DOSTUPNOSŤ ALL - A/B TEST
// Default vypnutý. Zapnutie cez head script v admine:
//   <script>window.abTestSkladAllEnabled = true;</script>
function runSkladAllTest() {
    if (window.abTestSkladAllEnabled !== true) return;
    if (document.querySelector('.admin-bar')) return;

    const categoriesConfig = [
        'Boxspring',
        'Šatníkové skrine',
        'Skrine do predsiene',
        'Do detskej izby',
        'Rohové skrine'
    ];

    const variant = abGetAssignment('WSK_POSTUPSN_2026_06_26_skladovost_boxspring_skrine');

    // Získame kategóriu, ak nesedí - ukončíme funkciu
    const breadcrumbs = abGetBreadcrumbs();
    if (!categoriesConfig.some(cat => breadcrumbs.includes(cat.toLowerCase()))) return;

    const groupTest = ['F', 'G', 'H', 'I', 'J'];

    // 50% test skupina (50:50 split)
    if (groupTest.includes(variant)) {
        const availabilitySpans = document.querySelectorAll('.product .availability span, .availability-value span');

        availabilitySpans.forEach(span => {
            // "Skladom" alebo "Skladom (> 5 ks)" a pod.
            if (span.textContent.trim().toLowerCase().includes('skladom')) {
                span.textContent = '1-4 týždne';
                span.style.color = '#4b4d4e';
            }
        });

        const amountElements = document.querySelectorAll('.availability-amount');
        amountElements.forEach(el => {
            el.style.display = 'none';
        });
    }   
}

//SKLADOVÁ DOSTUPNOSŤ MATRACE - A/B TEST
// VYPNUTÉ (#238): funkcia sa už nevolá z abTestConfig(). Ponechaná pre prípadné
// neskoršie zapnutie – stačí vrátiť volania runSkladMatraceTest() do abTestConfig().
// Zapínanie/vypínanie cez head script v admine:
//   <script>window.abTestSkladMatraceEnabled = true;</script>
// Bez nastavenia tejto premennej (alebo false) sa test nespustí.
function runSkladMatraceTest() {
    if (window.abTestSkladMatraceEnabled !== true) return;
    if (document.querySelector('.admin-bar')) return;

    const breadcrumbs = abGetBreadcrumbs();
    if (!breadcrumbs.includes('matrace') || breadcrumbs.includes('matrace na mieru')) return;

    const variant = abGetAssignment('WSK_MATR_2026_03_09_skladovost');

    const groupTestA = ['G', 'H'];
    const groupTestB = ['I', 'J'];

    // 20% A skupina
    if (groupTestA.includes(variant)) {
        const availabilitySpans = document.querySelectorAll('.product .availability span, .availability-value span');

        availabilitySpans.forEach(span => {
            // "Skladom" alebo "Skladom (> 5 ks)" a pod.
            if (span.textContent.trim().toLowerCase().includes('skladom')) {
                span.textContent = '5-10 pracovných dní';
                span.style.color = '#4b4d4e';
            }
        });

        const amountElements = document.querySelectorAll('.availability-amount');
        amountElements.forEach(el => {
            el.style.display = 'none';
        });
    }
    // 20% B skupina
    else if (groupTestB.includes(variant)) {

        const availabilitySpans = document.querySelectorAll('.product .availability span, .availability-value span');

        availabilitySpans.forEach(span => {
            // "Skladom" alebo "Skladom (> 5 ks)" a pod.
            if (span.textContent.trim().toLowerCase().includes('skladom')) {
                span.textContent = '1-3 týždne';
                span.style.color = '#4b4d4e';
            }
        });

        const amountElements = document.querySelectorAll('.availability-amount');
        amountElements.forEach(el => {
            el.style.display = 'none';
        });
    }
}

//CHECKOUT - A/B TEST
// Default vypnutý. Zapnutie cez head script v admine:
//   <script>window.abTestCheckoutEnabled = true;</script>
function runCheckoutTest() {
    if (window.abTestCheckoutEnabled !== true) return;
    if (document.querySelector('.admin-bar')) return;

    const variant = abGetAssignment('kosik_test');

    if (variant === 'A') {
        $("body").addClass(`checkout-a ${shopName}`);
    } else if (variant === 'B' && shopName === 'jam') {
        $("body").addClass(`checkout-b ${shopName}`);

        // --- SPÚŠŤAME FUNKCIE PRIAMO TU ---
        moveCoupon();
        addRelatedProductsToCart();
        checkoutButtonContinue();

        if (typeof window.freeShippingAmount !== 'undefined' && window.freeShippingAmount) {
            addCheckoutBenefits();
        }

        totalSaveMessage();
        productDiscountPrice();
        repositionContact();
        stickyCartSummary();
        emptyCart();
        // --- KONIEC ---
    }
}